import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { actions, actionTypes } from "../../../../Redux";
import ModelContainer from "../../../Components/ModelContainer";
import ErrorContainer from "../../../Components/ErrorContainer";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const RoomLayout = (params) => {
  // const [showForm, setShowForm] = useState(false);
  const showForm = useSelector(
    (state) => state?.settingReducer.rooms_layout_form_state
  );
  const setShowForm = (formState) =>
    dispatch(
      actions?.setFormState({ formName: "rooms_layout_form_state", formState })
    );

  const [formType, setFormType] = useState("add");
  const dispatch = useDispatch();
  const roomsLayoutData = useSelector(
    (state) => state?.settingReducer?.rooms_layout_data
  );
  const editRoomLayoutData = useSelector(
    (state) => state?.settingReducer?.edit_room_layout_data
  );

  console.log(roomsLayoutData, "roomsLayoutData");
  const [roomsLayoutDataArr, setRoomsLayoutDataArr] = useState(null);

  useEffect(() => {
    dispatch(actions.getRoomsLayoutData());
  }, []);
  useEffect(() => {
    setRoomsLayoutDataArr(roomsLayoutData);
  }, [roomsLayoutData]);
  const handleSearch = (e) => {
    const filteredArray = roomsLayoutData.filter((el) =>
      el.name.startsWith(e.target.value)
    );
    console.log(filteredArray, "filteredArray");
    setRoomsLayoutDataArr(filteredArray);
  };
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        {!showForm && (
          <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
            <div className="container px-0">
              <div class="top-header-sec pt-5 mb-5">
                <div class="col-12">
                  <div class="row d-flex justify-content-end">
                    <div class="table-layout-sec d-flex col-lg-4 col-sm-6 col-12">
                      <label class="col-5">Enable Table Layout</label>
                      <div class="select-div col-7">
                        <select
                          name="data[enable_table_layout]"
                          required="required"
                          id="enable_table_layout"
                        >
                          <option value="yes" selected="selected">
                            Yes
                          </option>
                          <option value="no">No</option>
                        </select>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          Room Layout Master
                        </h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center w-100 mx-0">
                            <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                              <div className="search-box mt-0">
                                <form>
                                  <input
                                    type="text"
                                    placeholder="Search"
                                    name="keyword1"
                                    onChange={(e) => handleSearch(e)}
                                  />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                            <div
                              onClick={() => {
                                setFormType("add");
                                setShowForm(true);
                              }}
                              class="col-sm-7 col-12 align-right px-0"
                            >
                              <p class="btn green-btn-revert add-plus mx-0">
                                <i class="i-icon"> </i> Add Layout{" "}
                              </p>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th class="header">
                                    <a href="">Room ID </a>
                                  </th>
                                  <th class="header">
                                    <a href="">Room Name</a>
                                  </th>
                                  <th width="" class="header">
                                    <a href="">Status</a>
                                  </th>
                                  <th class="header">Number of Tables</th>
                                  <th class="header">Seating Capacity</th>
                                  <th class="header">Last Upload Update</th>
                                  <th class="header">Last Pushdown Update</th>
                                  <th class="action-td">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {roomsLayoutDataArr?.map((el) => {
                                  return (
                                    <tr>
                                      <td>{el.id}</td>
                                      <td>{el.name}</td>
                                      <td width="">
                                        {el.active == "1"
                                          ? "Active"
                                          : "Inactive"}
                                      </td>
                                      <td>{el.table_count}</td>
                                      <td>{el.no_of_seats}</td>
                                      <td>{el.last_upload_update}</td>
                                      <td>{el.last_pushdown_update}</td>
                                      <td class="action-td">
                                        <div className="d-flex">
                                        <p
                                          onClick={() => {
                                            setFormType("edit");
                                            setShowForm(true);
                                            dispatch(
                                              actions.getEditRoomLayout(el.id)
                                            );
                                          }}
                                          className="circle_icon edit_tooltip"
                                        >
                                          <i class="iconSprites edit-icon"></i>{" "}
                                        </p>
                                        <p
                                          className="circle_icon edit_tooltip"
                                          onClick={() => {
                                            dispatch(
                                              actions.deleteRoomLayout({
                                                id: el.id,
                                              })
                                            );
                                          }}
                                        >
                                          <i class="iconSprites delete-icon"></i>
                                        </p>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* /////////////////// */}
      
      <div className="container px-0 d-flow-root">
      {showForm && (
        <RoomForm
          formType={formType}
          editFormData={editRoomLayoutData}
          setShowForm={setShowForm}
        />
      )}
      </div>
    </UserInterface>
  );
};

const RoomForm = ({ formType, editFormData, setShowForm }) => {
  const dispatch = useDispatch();
  const defaultAddFormState = {
    name: "",
    active: "",
  };
  const defaultEditFormState = {
    name: editFormData?.name,
    active: editFormData?.active,
  };
  const roomFormSchema = yup.object({
    name: yup.string().required(),
    active: yup.string().required(),
  });

  const {
    register: roomFormRegister,
    formState: { errors: roomFormErrors },
    handleSubmit: roomFormSubmit,
    reset: roomFormReset,
    setValue,
  } = useForm({
    resolver: yupResolver(roomFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add" ? defaultAddFormState : defaultEditFormState,
  });

  const submitData = (data) => {
    if (formType == "add") dispatch(actions.postAddRoomLayout(data));
    else dispatch(actions.postEditRoomLayout({ query: editFormData.id, data }));
  };
  useEffect(() => {
    roomFormReset(defaultAddFormState);
  }, []);
  useEffect(() => {
    if (formType === "edit") roomFormReset(defaultEditFormState);
    else roomFormReset(defaultAddFormState);
  }, [editFormData, formType]);
  return (
    <form onSubmit={roomFormSubmit(submitData)}>
      <div class="row-fluid">
        <div class="shadowclass padding_b mt-0">
          <div class="col-12">
            <h4 class="event-alert">ROOM 1 LAYOUT SETTINGS</h4>
          </div>
          <div className="row mx-0">
            <div class="col-6 m-0">
              <ul class="ingredient-info edit-shift">
                <li>
                  <label>Room Name</label>
                  <div class="input-group span7">
                    <input
                      {...roomFormRegister("name")}
                      class="required"
                      type="text"
                    />
                    <ErrorContainer errors={roomFormErrors} name="name" />
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-6 m-0">
              <ul class="ingredient-info edit-shift">
                <li>
                  <label class="required">Status</label>
                  <div class="input-group span7">
                    <select {...roomFormRegister("active")} class="required">
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>{" "}
                    <ErrorContainer errors={roomFormErrors} name="active" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>

      <div class="row mx-0">
        <div class="container px-0 d-flex col-12">
          <div class="btns col-4 d-flex justify-content-end py-4 col-12">
            <button type="submit">Save</button>
            <button
              onClick={() => setShowForm(false)}
              id="cancel"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default RoomLayout;
